define(['jquery', 'mage/translate'], function ($, $t) {
    'use strict'

    return function (options, element) {
        const config = { maxLines: options.maxLines || 2 }

        const description = $(element)
        const descriptionContent = description.find('.content')
        const descriptionInnerContent = descriptionContent.find('.inner-content')
        const lineHeight = parseFloat(descriptionInnerContent.css('line-height'))

        const originalHtml = descriptionInnerContent.html()
        let smallHtml = []

        const moreButton = `<a class="expand-link link-expand link link--invert">${$t('View more')}</a>`
        const minusButton = `<a class="expand-link link-contract link link--invert">${$t('View less')}</a>`

        const addButtons = () => {
            smallHtml = []
            const words = descriptionInnerContent.text().trim().split(' ')

            for (var i = 0; i < words.length; i++) {
                smallHtml.push(words[i])
                descriptionInnerContent.text(smallHtml.join(' '))

                const divHeight = descriptionInnerContent.outerHeight()
                const lines = Math.round(divHeight / lineHeight)

                if(lines > config.maxLines) {
                    descriptionInnerContent.text(descriptionInnerContent.text() + '... ')
                    descriptionInnerContent.html(descriptionInnerContent.text() + moreButton)
                    break
                }
            }

            let smallHtmlHeight = descriptionInnerContent.outerHeight()
            let smallHtmlLines = Math.round(smallHtmlHeight / lineHeight)
            while (smallHtmlLines > config.maxLines) {
                smallHtml.splice(-1)
                descriptionInnerContent.html(smallHtml.join(' ') + '... ' + moreButton)

                smallHtmlHeight = descriptionInnerContent.outerHeight()
                smallHtmlLines = Math.round(smallHtmlHeight / lineHeight)
            }
        }

        const calculate = () => {
            if (!description.hasClass('expand')) {
                reset()

                const divHeight = descriptionInnerContent.outerHeight()
                const lines = Math.round(divHeight / lineHeight)

                if (lines > config.maxLines) {
                    description.addClass('can-expand')
                    descriptionContent.css('max-height', lineHeight * config.maxLines + 'px')
                    addButtons()
                } else {
                    description.removeClass('can-expand')
                    descriptionContent.css('max-height', 'none')
                }
            } else {
                description.find('.link-contract').addClass('display-none')
                const divHeight = descriptionInnerContent.outerHeight()
                const lines = Math.round(divHeight / lineHeight)

                if (lines <= config.maxLines) {
                    reset()
                } else {
                    description.find('.link-contract').removeClass('display-none')
                }
            }
        }

        const reset = () => {
            descriptionInnerContent.html(originalHtml)
            description.removeClass('contract')
            description.removeClass('expand')
        }

        description.on('click', '.link-expand', () => {
            reset()
            if (descriptionInnerContent.children().length > 0) {
                descriptionInnerContent.children().last().append(' ' + minusButton)
            } else {
                descriptionInnerContent.append(' ' + minusButton)
            }

            description.removeClass('contract')
            description.addClass('expand')
        })

        description.on('click', '.link-contract', () => {
            description.removeClass('expand')
            description.addClass('contract')

            calculate()
        })

        calculate()

        $(window).resize(function () {
            calculate()
        })
    }
})
